import { StyledButton } from 'components/shared/Button/styles';
import { StyledSecondaryButton } from 'components/shared/SecondaryButton/styled';
import styled from 'styled-components';

export const StyledAdminConfirmModal = styled.div`
  background-color: #240e59;
  width: auto;
  max-width: 40%;
  box-shadow: 0px 11px 16px 0px rgba(0, 0, 0, 0.25);
  border-radius: 0.6rem;

  @media screen and (max-width: 1200px) {
    max-width: 70%;
  }

  ${StyledSecondaryButton} {
    padding: 0.8rem 5.1rem;
    border-radius: 0.9rem;
    border-color: #8de24a;
    color: #8de24a;

    @media screen and (min-width: 768px) {
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (min-width: 1440px) {
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (min-width: 2118px) {
      padding: 1.7rem 2.8rem;
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  ${StyledButton} {
    padding: 0.8rem 5.6rem;
    border-radius: 0.9rem;
    color: #240e59;

    @media screen and (min-width: 768px) {
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (min-width: 1440px) {
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (min-width: 2118px) {
      padding: 1.7rem 2.8rem;
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .confirm-modal {
    &-topline {
      padding: 1.4rem 1.8rem;
      border-bottom: 1px solid rgba(64, 30, 147, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-title {
      font-size: 1.8rem;
      font-weight: 500;
      line-height: 150%;
      text-transform: capitalize;

      @media screen and (max-width: 1440px) {
        font-size: 1.4rem;
      }

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    &-body {
      display: flex;
      padding: 3rem 0 6rem;
      justify-content: space-around;

      @media screen and (max-width: 1440px) {
        padding: 2.8rem 0 4rem;
      }
    }

    &-text {
      font-weight: 400;
      font-size: 1.8rem;
      line-height: 150%;
      text-align: center;
      max-width: 55%;
      text-transform: capitalize;

      @media screen and (max-width: 1440px) {
        font-size: 1.4rem;
      }

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    &-buttons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 4rem 2.7rem;
    }

    &-button {
      background-color: rgba(141, 226, 74, 0.2);
      border-radius: 50%;
      padding: 0.5rem 0.9rem;
    }
  }
`;
